import React, { useState } from 'react';
import { crearCliente } from '../services/clientesService';
import { mensajeAmigable } from '../utils/errores';
import { limpiarTelefono, telefonoValido, limpiarTexto } from '../utils/validacion';
import { useToast } from '../context/ToastContext';

// Botón "➕ Nuevo cliente" reutilizable: abre un mini-formulario, crea el
// cliente y lo devuelve por onCreado para dejarlo seleccionado.
export default function NuevoClienteInline({ onCreado, disabled }) {
  const { mostrarToast } = useToast();
  const [abierto, setAbierto] = useState(false);
  const [nombre, setNombre] = useState('');
  const [telefono, setTelefono] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [guardando, setGuardando] = useState(false);

  const input = { width: '100%', padding: '9px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' };

  const guardar = async () => {
    if (nombre.trim().length < 2) { mostrarToast('Escribe el nombre del cliente', 'error'); return; }
    if (telefono && !telefonoValido(telefono)) { mostrarToast('El teléfono debe tener al menos 8 números (o dejalo vacío)', 'error'); return; }
    setGuardando(true);
    try {
      const nuevo = await crearCliente({
        nombre, telefono,
        esLocal: !ciudad.trim(), ciudad: ciudad.trim() || null,
      });
      onCreado?.(nuevo);
      setAbierto(false); setNombre(''); setTelefono(''); setCiudad('');
      mostrarToast('Cliente creado ✅', 'exito');
    } catch (e) {
      mostrarToast(mensajeAmigable(e), 'error');
    } finally {
      setGuardando(false);
    }
  };

  if (!abierto) {
    return (
      <button type="button" disabled={disabled} onClick={() => setAbierto(true)}
        style={{ marginTop: '6px', padding: '6px 10px', background: 'white', border: '1px dashed var(--k-verde)', borderRadius: '8px', color: 'var(--k-verde)', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>
        ➕ Nuevo cliente
      </button>
    );
  }

  return (
    <div style={{ marginTop: '8px', padding: '10px', backgroundColor: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: '8px' }}>
      <input type="text" value={nombre} autoFocus disabled={guardando} placeholder="Nombre del cliente *"
        maxLength={80} onChange={(e) => setNombre(limpiarTexto(e.target.value, 80))} style={{ ...input, marginBottom: '6px' }} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px', marginBottom: '8px' }}>
        <input type="tel" value={telefono} disabled={guardando} placeholder="Teléfono (opcional)"
          inputMode="tel" onChange={(e) => setTelefono(limpiarTelefono(e.target.value))} style={input} />
        <input type="text" value={ciudad} disabled={guardando} placeholder="Ciudad (si es de otra)"
          maxLength={60} onChange={(e) => setCiudad(limpiarTexto(e.target.value, 60))} style={input} />
      </div>
      <div style={{ display: 'flex', gap: '6px' }}>
        <button type="button" onClick={() => setAbierto(false)} disabled={guardando}
          style={{ flex: '0 0 auto', padding: '7px 12px', background: 'white', border: '1px solid #D1D5DB', borderRadius: '8px', color: '#6B7280', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}>
          Cancelar
        </button>
        <button type="button" onClick={guardar} disabled={guardando}
          style={{ flex: 1, padding: '7px', backgroundColor: guardando ? '#9CA3AF' : 'var(--k-verde)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: 700, cursor: guardando ? 'wait' : 'pointer' }}>
          {guardando ? '⏳...' : 'Guardar cliente'}
        </button>
      </div>
    </div>
  );
}
